'use client';
/** @jsxImportSource @emotion/react */

import type { ButtonBaseTypeMap as MuiButtonBaseTypeMap } from '@mui/material';

import MuiButtonBase from '@mui/material/ButtonBase';
import {
  type OverridableComponent,
  type OverrideProps,
} from '@mui/material/OverridableComponent';

type ExcludedMuiProps =
  | 'color'
  | 'disableElevation'
  | 'disableFocusRipple'
  | 'disableRipple';

type ButtonBaseTypeMap<
  D extends React.ElementType = MuiButtonBaseTypeMap['defaultComponent'],
  P = {
    component?: React.ElementType;
  },
> = {
  defaultComponent: D;
  props: Omit<MuiButtonBaseTypeMap['props'], ExcludedMuiProps> & P;
};

type ButtonBaseProps<
  D extends React.ElementType = MuiButtonBaseTypeMap['defaultComponent'],
  P = {
    component?: React.ElementType;
  },
> = OverrideProps<MuiButtonBaseTypeMap<P, D>, D>;

export type { ButtonBaseProps };
export const ButtonBase: OverridableComponent<ButtonBaseTypeMap> = (
  props: ButtonBaseProps
) => <MuiButtonBase {...props} />;
